/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import LessonOverview from './LessonOverview';
import { useTranslation } from 'react-i18next';

function StyledButton(props) {
  const { selected, onClick, label, disabled } = props;
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className={`${
        selected
          ? 'bg-grey-dark text-white'
          : 'bg-white text-grey-dark border-2 border-grey-dark'
      } font-thin rounded-full pt-2 pb-2 pl-6 pr-6`}
      onClick={onClick}
      disabled={disabled}
    >
      <p>{label}</p>
    </button>
  );
}

StyledButton.propTypes = {
  selected: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

function CourseOverview(props) {
  const user = useSelector((state) => state.user.singleUser);
  const { t } = useTranslation();
  const onClickPlaceholder = () => {
    return;
  };

  const { course } = props;

  return (
    <div className="w-full flex-col space-y-3 p-3">
      <section className="">
        <h1 className="text-grey-dark font-bold text-xl">{course?.title}</h1>
        <h2 className="text-grey-dark text-base pt-4">{course?.lorem}</h2>
        <p>{course?.description}</p>
      </section>
      <section>
        <LessonOverview
          lessons={course.lessons}
          isAdmin={user.role === 'ADMIN' || user.role === 'SUPER_ADMIN'}
        />
      </section>
    </div>
  );
}

CourseOverview.propTypes = {};

export default CourseOverview;
